import { setPointsForExerciseInProgressInitState } from './InitState';
import CURSE_INSTANCE_ACTIONS from '../../../Actions/ActionTypes';
import { IAction } from '../../../../../__core/Interfaces/IAction';
import { ISetPointsForExerciseInProgress } from '../Interfaces/ISetPointsForExerciseInProgress';

export const setPointsForExerciseInProgressReducer = (
  state: Array<ISetPointsForExerciseInProgress> = setPointsForExerciseInProgressInitState,
  action: IAction<ISetPointsForExerciseInProgress>
): Array<ISetPointsForExerciseInProgress> => {
  switch (action.type) {
    case CURSE_INSTANCE_ACTIONS.SET_POINTS_FOR_EXERCISE_START:
      return [...state, action.payload];

    case CURSE_INSTANCE_ACTIONS.SET_POINTS_FOR_EXERCISE_FINISH:
      return [
        ...state.filter(
          (value) =>
            value.exerciseId !== action.payload.exerciseId &&
            value.studentId !== action.payload.studentId
        ),
      ];

    default:
      return state;
  }
};
